// actions.js
export const INIT_OIL_LIST_REQUEST = 'INIT_OIL_LIST_REQUEST';
export const SET_OIL_LIST = 'SET_OIL_LIST';
export const ERROR_OIL_LIST = 'ERROR_OIL_LIST';

export const INIT_OIL_REQUEST = 'INIT_OIL_REQUEST';
export const SET_OIL = 'SET_OIL';
export const ADD_OIL = 'ADD_OIL';
export const UPDATE_OIL = 'UPDATE_OIL';
export const ERROR_OIL_REQUEST = 'ERROR_OIL_REQUEST';
export const DELETE_OIL = "DELETE_OIL";

export function initOilListRequest() {
  return { type: INIT_OIL_LIST_REQUEST };
}

export function setOilList(data) {
  return { type: SET_OIL_LIST, payload: data };
}

export function errorOilList(error) {
  return { type: ERROR_OIL_LIST, payload: error };
}

export function addOil() {
  return { type: ADD_OIL };
}

export function updateOil(oil) {
  return { type: UPDATE_OIL, payload: oil };
}

export function initOilRequest() {
  return { type: INIT_OIL_REQUEST };
}

export function setOil(data) {
  return { type: SET_OIL, payload: data };
}

export function errorOilRequest(error) {
  return { type: ERROR_OIL_REQUEST, payload: error };
}

export function deleteOil(data) {
  return { type: DELETE_OIL, payload: data };
}